module.exports = __webpack_public_path__ + "img/banner-login.c7dd3593.png";